import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { maintenance_info } from "../../api/axiosInstanceApi";
import { ToastContainer } from "react-toastify";

function LinkedInCallback() {
  const [params] = useSearchParams();

  const navigate = useNavigate();
  async function maintenance_api() {
    const m_res = await maintenance_info();
    return m_res.data.m;
  }
  useEffect(() => {
    async function run() {
      try {
        const success = params.get("success");
        const name = params.get("name");
        const email = params.get("email");
        const mentee_id = params.get("mentee_id");
        const login_type = params.get("login_type");
        const error = params.get("error"); // 👈 backend error message

        let user_data = {
          email: email,
          name: name,
          mentee_id: mentee_id,
          login_type:login_type
        };

        if (success === "true") {
          localStorage.setItem("mentee_data", JSON.stringify(user_data));
          const maintenance = await maintenance_api();
          navigate("/", { state: { maintenance } });
        } else {
          // let message = "LinkedIn login failed. Please try again.";
          if (error) {
            // switch (error) {
            //   case "missing_code":
            //     message = "Login failed: Missing authorization code.";
            //     break;
            //   case "access_denied":
            //     message = "You denied LinkedIn access.";
            //     break;
            //   case "no_access_token":
            //     message = "Login failed: Could not retrieve access token.";
            //     break;
            //   case "invalid_access_token":
            //     message = "Login failed: Invalid LinkedIn session.";
            //     break;
            //   case "missing_email":
            //     message = "We couldn’t retrieve your LinkedIn email.";
            //     break;
            //   case "db_error":
            //     message = "Server error while fetching user info.";
            //     break;
            //   case "server_error":
            //   default:
            //     message = "Unexpected server error. Please try again later.";
            //     break;
            // }
            navigate("/login", {
              state: {
                errorMessage:  "LinkedIn login failed. Please try again."
              }
            });
          }
        }
      } catch (err: any) {
        console.log("");
        navigate("/login", {
          state: { errorMessage: "Unexpected error. Please try again." }
        });
      }
    }
    run();
  }, []);

  return (
    <div className="text-white p-3">
      Redirecting...
      <ToastContainer></ToastContainer>
    </div>
  );
}

export default LinkedInCallback;
